import { ManifestClientService } from '../services/manifest-client.service';
import { AnalyticsService } from '../services/analytics.service';
import { TranslationService } from '../services/translation.service';
import { IdentityClientService } from '../services/identity-client.service';
import { TrackingService } from '@meltwater/mi-ia-tracking';
import { Environment } from '../services/environment.service';
import { AuthService } from 'services/auth.service';
import { initPendo } from 'utils/pendo';

export default () => {
  const init = async () => {
    console.log('App is ready');
    window?.appContainerPlaceholder?.remove();
    let origin = window.location.origin;

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `${Environment.MY_PRECIOUS_URL}`;

    if (document.querySelectorAll(`script[src="${Environment.MY_PRECIOUS_URL}"]`).length < 1) {
      document.getElementsByTagName('script')[0]?.parentNode?.appendChild(script);
    }

    IdentityClientService.init();
    IdentityClientService.configureErrorHandler();
    ManifestClientService.init();

    TrackingService.initTrackingSession('engage-homepage-web-application');
    TrackingService.sendTrackingEvent(
      'page-load',
      {
        referrer: document?.referrer || null,
        browser: navigator?.userAgent,
      },
      'engage-homepage-web-application'
    );

    TranslationService.setLanguage('en');

    AnalyticsService.identifyUser();

    const manifest = await ManifestClientService.getManifest();

    if (origin.includes('localhost')) {
      origin = 'https://staging.meltwater.net';
    }

    if (manifest?.user?.appPermissions?.engage === 'RESTRICTED') {
      window.location.href = `${origin}/home`;
    }

    initPendo(manifest?.user?._id, manifest?.user?.email, manifest?.company?._id, manifest?.company?.name);
  };

  // temporary hack to logout user if token is invalid until we align with app chrome
  AuthService.getCurrentAuthPayload();

  if (window['AppChrome'] && window['AppChrome'].ready === true) {
    init();
  } else {
    window.addEventListener('app-chrome-ready', () => {
      init();
    });
  }
};
